import type { StudentSession } from '@airreading/common/data';
import { StudentSessionCard } from './student-session-card.js';
import noClassesIcon from '@/assets/images/NoSessionImage/no-upcoming-class-asset.svg';

export interface SessionSectionProps {
  title: string;
  studentName: string;
  sessionsList: StudentSession[];
  isFuture?: boolean;
  'data-testid'?: string;
}

export const SessionSection = ({
  title,
  studentName,
  sessionsList,
  isFuture = false,
  'data-testid': dataTestId,
}: SessionSectionProps) => {
  const headerTestId = dataTestId ? `${dataTestId}-header` : undefined;

  return (
    <div className="mb-7">
      <div className="flex items-center">
        <div className="bg-[#EB404A] w-[6px] h-[24px] mr-2" aria-hidden="true" />
        <h2 className="flex items-center font-bold text-2xl my-2" data-testid={headerTestId}>
          {title}
        </h2>
      </div>
      {sessionsList.length === 0 ? (
        <div className="flex min-w-0 flex-col items-center justify-center py-8 w-full">
          <img src={noClassesIcon} alt="" aria-hidden="true" className="w-[100px] h-[100px]" />
          <span className="font-normal text-base leading-6 tracking-[-0.75%] text-center align-middle text-gray-400 mt-4">
            No classes have been scheduled at the moment.
          </span>
        </div>
      ) : (
        <div className="flex gap-4 flex-wrap min-w-0">
          {sessionsList.map((studentSession, index) => (
            <StudentSessionCard
              key={studentSession.sessionId}
              studentSession={studentSession}
              studentName={studentName}
              isFuture={isFuture}
              index={index}
            />
          ))}
        </div>
      )}
    </div>
  );
};
